module.exports = require('./dist/react-data-grid');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-data-grid/index.js
 ** module id = 161
 ** module chunks = 0
 **/